module.exports = __webpack_public_path__ + "img/logo.ac4d8139.png";